import React from 'react';
import PropTypes from 'prop-types';
import style from './style.module.scss';

/**
 * Label:
 *  - Label for Menu in Notebook/MenuList
 */
export function Label(props) {
  const className = `${style.label} ${props.className}`;

  return <div className={className}>{props.title}</div>;
}

Label.propTypes = {
  /**
   * Menu Title
   */
  title: PropTypes.string,
};

Label.defaultProps = {
  title: '',
};
